import { Col } from "react-bootstrap";
import { MENU_GROUPS, getGroupSteps } from "../../constants/menuConfig";

export const AdminSidebar = ({
  sidebarOpen,
  currentStep,
  expandedGroups,
  expandedSections,
  toggleMenuGroup,
  toggleMenuSection,
  selectStep,
  menuGroups = MENU_GROUPS,
  brandTitle = "List of menus",
}) => (
          <Col
            md={3}
            lg={2}
            className={`authdata-left ${sidebarOpen ? "open" : ""}`}
          >
            <div className="authdata-brand">{brandTitle}</div>
            <ul className="authdata-steps">
              {menuGroups.map((group) => {
                if (group.step != null && !group.sections) {
                  const isActive = group.step === currentStep;
                  return (
                    <li key={group.id} className="authdata-menu-group">
                      <button
                        type="button"
                        className={`authdata-menu-group-header authdata-menu-group-header--link ${isActive ? "expanded has-active is-active" : ""}`}
                        onClick={() => selectStep(group.step)}
                      >
                        <span className="authdata-menu-group-label">{group.label}</span>
                      </button>
                    </li>
                  );
                }
                const isExpanded = !!expandedGroups[group.id];
                const groupSteps = getGroupSteps(group);
                const hasActiveChild = groupSteps.includes(currentStep);
                return (
                  <li key={group.id} className="authdata-menu-group">
                    <button
                      type="button"
                      className={`authdata-menu-group-header ${isExpanded ? "expanded" : ""} ${hasActiveChild ? "has-active" : ""}`}
                      onClick={() => toggleMenuGroup(group.id)}
                      aria-expanded={isExpanded}
                    >
                      <span className="authdata-menu-group-label">{group.label}</span>
                      <span className={`authdata-menu-chevron ${isExpanded ? "open" : ""}`} aria-hidden="true">
                        ▾
                      </span>
                    </button>
                    {isExpanded && group.sections && (
                      <ul className="authdata-submenu authdata-submenu--nested">
                        {group.sections.map((section) => {
                          const sectionKey = `${group.id}:${section.id}`;
                          const isSectionExpanded = !!expandedSections[sectionKey];
                          const sectionSteps = section.step != null
                            ? [section.step]
                            : (section.items || []).filter((item) => item.step != null).map((item) => item.step);
                          const sectionHasActive = sectionSteps.includes(currentStep);

                          if (section.step != null) {
                            return (
                              <li
                                key={section.id}
                                className={`authdata-step-item authdata-submenu-item authdata-section-link ${section.step === currentStep ? "active" : "inactive"}`}
                                onClick={() => selectStep(section.step)}
                              >
                                <span className="step-label">{section.label}</span>
                              </li>
                            );
                          }

                          if (!section.items) {
                            return (
                              <li
                                key={section.id}
                                className="authdata-step-item authdata-submenu-item authdata-section-link authdata-submenu-item--disabled"
                              >
                                <span className="step-label">{section.label}</span>
                              </li>
                            );
                          }

                          return (
                            <li key={section.id} className="authdata-menu-section">
                              <button
                                type="button"
                                className={`authdata-menu-section-header ${isSectionExpanded ? "expanded" : ""} ${sectionHasActive ? "has-active" : ""}`}
                                onClick={() => toggleMenuSection(group.id, section.id)}
                                aria-expanded={isSectionExpanded}
                              >
                                <span className="authdata-menu-section-label">{section.label}</span>
                                <span className={`authdata-menu-chevron ${isSectionExpanded ? "open" : ""}`} aria-hidden="true">
                                  ▾
                                </span>
                              </button>
                              {isSectionExpanded && (
                                <ul className="authdata-submenu authdata-submenu--child">
                                  {section.items.map((item) => (
                                    item.step == null ? (
                                      <li
                                        key={`${section.id}-${item.label}`}
                                        className="authdata-step-item authdata-submenu-item authdata-submenu-item--child authdata-submenu-item--disabled"
                                      >
                                        <span className="step-label">{item.label}</span>
                                      </li>
                                    ) : (
                                      <li
                                        key={`${section.id}-${item.step}`}
                                        className={`authdata-step-item authdata-submenu-item authdata-submenu-item--child ${item.step === currentStep ? "active" : "inactive"}`}
                                        onClick={() => selectStep(item.step)}
                                      >
                                        <span className="step-label">{item.label}</span>
                                      </li>
                                    )
                                  ))}
                                </ul>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>
          </Col>

);
